<template>
  <div class="full-page h-100" style="background: white;">
    <div id="history-container" class="container h-100" style="overflow-y: scroll; padding-bottom: 10px;">
      <div class="row" v-if="orderItem != false">
        <div class="col-12" style="padding-top: 30px;">

          <img src="https://storage.googleapis.com/menus-275719.appspot.com/icons/kh_attention_ic.png" style="width: 30px;"/>
          <div style="font-weight: bold; color:#E7344C; font-size: 1.2rem; padding-top: 10px; max-width: 300px; margin: auto;">{{getOrderText(orderItem.state, orderItem.recordType)}}</div>

          <div style="display: flex; justify-content: center; align-items: center; margin-top: 10px;" v-if="orderItem.state >= 0 && orderItem.state <= 6">
            <div class="status-icon-box status-icon-0" :class="{'enabled': orderItem.state >= 0}">

            </div>
            <div class="status-icon-box">
              <div class=" dotted-line" :class="{'enabled': orderItem.state >= 4}"></div>

            </div>
            <div class="status-icon-box status-icon-4" :class="{'enabled': orderItem.state >= 4}">

            </div>
            <div class="status-icon-box">
              <div class="dotted-line" :class="{'enabled': orderItem.state >= 5}">

              </div>
            </div>
            <div class="status-icon-box status-icon-5" :class="{'enabled': orderItem.state >= 5}">

            </div>
            <div class="status-icon-box">
              <div class="dotted-line" :class="{'enabled': orderItem.state === 6}">

              </div>
            </div>
            <div class="status-icon-box status-icon-6" :class="{'enabled': orderItem.state === 6}">

            </div>
          </div>

          <div class="order-item-container" style="background: #f5f5f5; margin-top: 20px; border:none;">
            <div style="display: flex;">
              <div class="order-item-merchant" style="width: 60%;">{{orderItem.merchantName}}</div>
              <div class="order-item-merchant text-right" style="width: 40%;">#{{orderItem.id}}</div>
            </div>

            <div style="font-size: 0.8rem;">{{orderItem.name}}, {{orderItem.phoneNumber}}
              <br/>Order Time: {{new Date(orderItem.createdTimestamp).toLocaleString()}}
            </div>
            <div v-if="orderItem.address != null && orderItem.address.length > 0" class="order-item-merchant-address" style="margin-top: 10px; margin-bottom: 10px;">
              <div >Deliver to</div>
              <span style="font-weight: bold;" v-html="orderItem.address.replace(/\n/g, '<br>')"></span>
              <div v-if="orderItem.postCode != null && orderItem.postCode.length > 0">{{orderItem.postCode}}</div>
            </div>
            <div v-if="orderItem.recordType === 1" style="font-size: 1rem; font-weight: bold;">Collection at: {{orderItem.pickupTime}}</div>
            <div>
              <span v-if="orderItem.recordType === 1" style="color: #E7344C; font-weight: bold;">Pickup Location:</span> <span v-html="orderItem.merchantAddress.replaceAll('<br/>', ', ')"/>
            </div>
<!--            <div class="order-item-merchant-address" >-->

<!--              <span v-html="orderItem.merchantAddress"/>-->
<!--            </div>-->
            <iframe v-if="orderItem.recordType === 1 && restaurant !== false && restaurant.webSetting !== undefined && restaurant.webSetting.googleMap !== null && restaurant.webSetting.googleMap.length > 0" :src="restaurant.webSetting.googleMap" width="100%" height="200px" frameborder="0" style="border:0"
                    allowfullscreen></iframe>
            <div class="order-item-merchant-info" v-if="orderItem.merchantInfo != undefined && orderItem.merchantInfo != null">
              <div v-if="orderItem.merchantInfo.merchantAddress != undefined && orderItem.merchantInfo.merchantAddress != null" v-html="orderItem.merchantInfo.merchantAddress.replace(/\n/g, '<br>')"></div>
              <div v-if="orderItem.merchantInfo.contact != undefined && orderItem.merchantInfo.contact != null"><a :href="'tel:'+ orderItem.merchantInfo.contact">{{orderItem.merchantInfo.contact}}</a></div>
            </div>
            <hr>
<!--            <div class="order-item-title">Order Time: {{new Date(orderItem.createdTimestamp).toLocaleString()}}</div>-->
<!--            <div class="order-item-status"><strong>Status</strong></div>-->
<!--            <div v-if="orderItem.state < 5 && orderItem.pickupTime != null && orderItem.pickupTime.length > 0"><strong><span v-if="orderItem.recordType == 1">Pickup Time:</span><span v-if="orderItem.recordType == 2">Delivery Time:</span></strong> {{orderItem.pickupTime}}</div>-->
<!--            <div class="order-item-status"><strong>Status</strong></div>-->
<!--            <div class="lds-ring" v-if="orderItem.state == 0"><div></div><div></div><div></div><div></div></div>-->
<!--            <div style="font-weight: bold;" v-html="getOrderStateString(orderItem.state, orderItem.recordType, orderItem.merchantName)"></div>-->

            <template v-if="orderItem.recordType == 2 && orderItem.deliveryJob != null">
              <br>
              <div class="order-item-status"><strong>Delivery Status</strong></div>
              <div class="delivery-status" v-for="state in deliveryStatusList" v-if="state.status == deliveryJob.state">{{state.title}}</div>
<!--              <div>{{orderItem.deliveryJob.lat}},{{orderItem.deliveryJob.lng}}</div>-->
            </template>
<!--            <span id="order-detail-btn" data-toggle="collapse" data-target="#order-details" aria-expanded="false">Details</span>-->
          </div>
          <div style="text-align: left; padding: 10px; background: #fdede5; margin-top: 10px;">
            <div id="order-details" class="collapse show" :aria-labelledby="'order-detail-btn'">
              <div class="order-item-description">
                <div class="order-section-title pt-0" >Order details</div>
                <table class="table">
                  <tr v-for="order in orderItem.list">
                    <td>{{getHistoryOrderItemName(order)}} x {{order.amount}}<span v-if="order.memo != null && order.memo.length > 0"><br>Memo:{{order.memo}}</span></td>
                    <td class="text-right">£{{(order.totalPrice/100).toFixed(2)}}</td>
<!--                    <td class="text-right">£{{(order.taxAmount/100).toFixed(2)}}</td>-->
                  </tr>
                  <tr v-if="orderItem.deliveryCharge > 0">
                    <td>Delivery Charge</td>
                    <td class="text-right">£{{(orderItem.deliveryCharge/100).toFixed(2)}}</td>
                  </tr>
                </table>

              </div>
              <div v-if="orderItem.memo != null && orderItem.memo.length > 0">Memo: {{orderItem.memo}}</div>




              <div class="order-item-price">Due £{{((orderItem.totalPrice/100).toFixed(2))}}</div>
              <div class="order-item-price" v-if="orderItem.discountAmount > 0">{{orderItem.discountTitle}}: -£{{((orderItem.discountAmount/100).toFixed(2))}}</div>
              <div class="order-item-price">Total £{{((orderItem.totalDue/100).toFixed(2))}}</div>
              <div class="paid-info" v-if="orderItem.state > 0 && orderItem.cardPayment > 0">Card Payment £{{(orderItem.cardPayment/100).toFixed(2)}}</div>
              <div class="paid-info" style="color:red;" v-if="orderItem.refundAmount > 0">Refund £{{(orderItem.refundAmount/100.0).toFixed(2)}}</div>
              <div class="paid-info" v-if="(orderItem.paymentMethod === 'webCard' || orderItem.paymentMethod === 'stripe') && orderItem.state < -1">Payment Failed ({{orderItem.state}})</div>
            </div>
<!--            <div v-if="points != false && orderItem.points > 0">-->
<!--              {{orderItem.points}} {{points.unitTitle}}-->
<!--            </div>-->
          </div>

        </div>
      </div>
      <div class="container fixed-bottom" style="display: none;" v-if="(orderItem.paymentMethod === 'webCard' || orderItem.paymentMethod === 'stripe')">
        <div class="row">
          <div class="col-12" style="padding-bottom: 10px;">
            <input type="text" class="form-control" v-model="receiptEmail" placeholder="email to get receipt"/>
          </div>
          <div class="col-12" style="padding-bottom: 20px;">
            <button class="btn btn-success form-control" v-on:click="sendReceipt(orderItem.id)">Receipt</button>
          </div>
        </div>
      </div>
      <v-dialog/>
    </div>
  </div>
</template>

<script>
  const axios = require('axios');
  import {
    getJonStatus,
    getOrder,
    getMyPendingOrder,
    updatePaymentItem,
    getMyOrderDeliveryJob,
    getDistance, sendReceipt, getMerchant
  } from "../api/borium";
    import QrcodeVue from 'qrcode.vue'
    import VueTimepicker from "vue2-timepicker";
    import {Slider, SliderItem} from "vue-easy-slider";
    import Bottom from "./Bottom";
    import EventBus from "../api/event-bus";
    export default {
        name: "Order",
      data() {
          return {
            // orderItem:false,
            message:'',
            leave: false,
            orderItems:[],
            orderItem:false,
            deliveryJob: false,
            food:false,
            deliveryStatusList:getJonStatus(),
            center: {
              lat:0,lng:0
            },
            restaurant: false,
            destination: false,
            lines:[],
            receiptEmail:'',
          }
      },
      components: {
        QrcodeVue,
        Bottom,
      },
      created() {
          // console.log("myorder craated");
      },
      mounted() {
        // console.log("myorder mounted");
        this.getOrderItem();
        EventBus.$emit("setTitle", "Order");
      },
      updated() {
        // console.log("myorder updated");

        // this.getOrderItem();
      },
      beforeDestroy() {
          this.$data.leave = true;
      },
      watch: {
        $route() {
          this.getOrderItem();
        }
      },
      methods: {
        backPressed: function(fromNav = false) {
          if(fromNav == true) {
            // Router.push('/home');
            history.go(-1)
          }
          return false;
        },
        getOrderItem: function() {
          let self = this;

          // console.log("getOrderId");
          if (this.$route.query.hasOwnProperty('id')) {
            let id = this.$route.query.id;
            // EventBus.$emit("showLoading", true, "Getting Order");
            getOrder(id)
            .then(function(data) {
              // EventBus.$emit("showLoading", false);
              if(data.success == true) {

                // if(self.$route.query.hasOwnProperty("result")) {
                //   if(data.item.state != -1) {
                //     self.$router.push('/myorder?id=' + data.item.id);
                //     return;
                //   }
                //   self.updateOrderItem(data.item, self.$route.query.result);
                //   return;
                // }
                // console.log("get order item");
                // console.log(data.item);

                for(let i = 0 ; i < data.item.list.length ; i++) {
                  data.item.list[i].taxAmount = data.item.list[i].totalPrice * data.item.list[i].taxRate / (10000 + data.item.list[i].taxRate);
                }
                self.$data.orderItem = data.item;
                // console.log(data.item);
                // if(self.$data.orderItem.recordType == 2) {
                //   self.setLocations();
                // }
                if(self.$data.orderItem.state >= 6 || self.$data.orderItem.state < 0) {
                  return;
                }
                // if(self.$data.orderItem.recordType == 2) {
                //   // console.log("call getJobItem");
                //   setTimeout(self.getJobItem, 3000);
                // } else {
                //   console.log("call getOrderItem");
                  setTimeout(self.getOrderItem, 3000);
                  self.getRestaurantInfo();
                // }

              } else {
                self.$data.message = data.message;
              }
            })
            .catch(function(err) {
              // EventBus.$emit("showLoading", false);
              // console.log("Error at getting order item " + err)
              // if(err.response != undefined) {
              //   console.log(err.response);
              // }
            })
          } else {
            // console.log("tel " + localStorage.getItem("tel"));
            if(localStorage.getItem("tel") !== null && localStorage.getItem("tel") !== "undefined" && localStorage.getItem("tel").length > 10) {
              getMyPendingOrder(localStorage.getItem("tel"))
              .then(function(data) {
                // console.log(data);
                if(data.success == true) {
                  for(let i = 0 ; i < data.item.length ; i++) {
                    self.updateItem(data.item[i]);
                  }
                  setTimeout(self.getOrderItem, 3000);
                } else {
                  self.$data.message = data.message;
                }
              })
              .catch(function(err) {
                // console.log("err " + err);
                // if(err.response != undefined) {
                //   console.log(err.response);
                // }
              })
            }
          }
        },
        getRestaurantInfo: function() {
          let self = this;
          getMerchant(this.$data.orderItem.subscriptionId)
            .then(function(data) {
              if(data.success === true) {
                self.$data.restaurant = data.item;
              }
            })
            .catch(function(err) {

            })
        },
        updateItem: function(item) {
          let found = false;
          this.$data.orderItem = item;
          // for(let i = 0 ; i < this.$data.orderItems.length ; i++) {
          //   if(this.$data.orderItems[i].id == item.id) {
          //     console.log(item);
          //     this.$data.orderItems.splice(i, 1, item);
          //     found = true;
          //   }
          // }
          // if(found == false) {
          //   this.$data.orderItems.push(item);
          // }
        },
        deliveryUpdate: function() {
          for(let i = 0 ; i < this.$data.orderItems.length ; i++) {
            if(this.$data.orderItems[i].orderType == 2 &&
              this.$data.orderItems[i].deliveryJob != undefined &&
              this.$data.orderItems[i].deliveryJob != null &&
              this.$data.orderItems[i].deliveryJob.state < 5) {
              getOrder(id)
                .then(function(data) {

                })
                .catch(function(err) {

                })
            }
          }
        },
        updateJobItem: function(id) {

        },
        getHistoryOrderItemName: function(item) {
          let title = item.menuName;
          let optionSelection = item.optionSelection;
          let optionList = [];
          if (optionSelection != null && optionSelection.length > 0) {
            let options = JSON.parse(optionSelection);
            for (let j = 0; j < options.length; j++) {
              if (options[j].field != undefined) {
                optionList.push(options[j].field);
              }
            }
          }


          if(optionList.length > 0) {
            title += ' (' + optionList.join(', ') + ')';
          }



          return title;
        },
        getOrderText: function(state, type) {
          if(state == 0) {
            return 'Your order is waiting for acceptance';
          } else if(state == 1) {
            return 'Change Request!. Please Confirm change';
          } else if(state == 2) {
            return 'Change Accepted';
          } else if(state == 3) {
            return 'Your order is accepted.'
          } else if(state == 4) {
            return 'Your order is in kitchen';
          } else if(state == 5) {
            if(type == 1) {
              return 'Your order is ready for collection';
            } else if(type ==2) {
              return 'Your order is on the way to you';
            }
          } else if(state == 6) {
            if(type == 1) {
              return 'Your order is completed';
            } else if(type === 2) {
              return 'Your order has been Delivered';
            }
          } else if(state == 7) {
            return 'Your order is Cancelled';
          } else if(state == -1000) {
            return 'Payment Cancelled';
          } else if(state == -2000) {
            return 'Payment Refunded';
          } else if(state < 0) {
            return 'Failed'
          }
          return 'Unknown(' + state + ')';
        },
        getOrderStateString: function(state, type, merchantName) {
          if(state == 0) {
            return '<strong><span style="color:red">Waiting for acceptance</span></strong>';
          } else if(state == 1) {
            return 'Change Request!. Please Confirm change';
          } else if(state == 2) {
            return 'Change Accepted';
          } else if(state == 3) {
            return 'Your order is accepted.'
          } else if(state == 4) {
            return 'Your order is in kitchen';
          } else if(state == 5) {
            if(type == 1) {
              return 'Your order is ready for collection';
            } else if(type ==2) {
              return 'Your order is on the way to you';
            }
          } else if(state == 6) {
            if(type == 1) {
              return 'Done';
            } else if(type === 2) {
              return 'Delivered';
            }
          } else if(state == 7) {
            return 'Cancelled';
          } else if(state == -1000) {
            return 'Payment Cancelled';
          } else if(state == -2000) {
            return 'Payment Refunded';
          } else if(state < 0) {
            return 'Failed'
          }
          return 'Unknown(' + state + ')';
        },

        refreshDeliveryPosition: function() {
          setTimeout(this.getJobItem, 3000);
        },
        getJobItem: function() {
          if(this.$data.orderItem == false || this.$data.orderItem.recordType != 2)  {
            // console.log("No delivery item")
            return;
          }

          if(this.$data.orderItem.state < 0 || this.$data.orderItem.state >= 6) {
            return;
          }
          if(this.$data.deliveryJob != false && this.$data.deliveryJob.state == 5) {
            // console.log("Job finished");
            return;
          }
          if(this.$data.orderItem.jobId == 0) {
            // console.log("Jobs not assigned yet");
            setTimeout(this.getOrderItem, 3000);
            return;
          }
          let self = this;
          // console.log("get Job");
          getMyOrderDeliveryJob(this.$data.orderItem.jobId)
          .then(function(data) {
            // console.log("Job Item ")
            // console.log(data);
            if(data.success == true) {
              if(self.$data.deliveryJob == false) {
                self.$data.deliveryJob = data.item;
                self.setLocations();

              } else {
                self.$data.deliveryJob = data.item;
              }
              if(self.$data.deliveryJob.state >= 0) {
                if (self.$data.food == false) {
                  self.$data.food = {
                    lat:data.item.positionLat,
                    lng:data.item.positionLng,
                  }
                } else {
                  self.$data.food.lat = data.item.positionLat;
                  self.$data.food.lng = data.item.positionLng;
                }
                // self.moveMap();
                // console.log("Food position update");
                // console.log(self.$data.food);
              } else {
                // console.log("State is not ready yet");
              }
              // console.log("delivery job");
              // console.log(self.$data.deliveryJob);
            }
            self.refreshDeliveryPosition();

          })
          .catch(function(err) {
            self.refreshDeliveryPosition();
            // console.log(err);
            // if(err.response != undefined) {
            //   console.log(err.response);
            // }
          })
        },
        moveMap: function() {
          // let self = this;
          // console.log("gmap");
          // console.log(this.$refs.gmap);
          // this.$refs.gmap.$mapPromise.then((map) => {
          //   map.panTo(self.$data.food);
          //   map.setZoom(17);
          //   //map.fitBounds(bounds);
          //
          // });
        },
        setLocations: function() {
          if(this.$data.orderItem == false) {
            return;
          }
          this.$data.restaurant = {
            lat:this.$data.deliveryJob.lat,
            lng:this.$data.deliveryJob.lng
          }
          // console.log("Restaurant Position");
          // console.log(this.$data.restaurant);
          this.getRoutes();
        },
        getRoutes: function() {
          let orig = this.$data.deliveryJob.lat + "," + this.$data.deliveryJob.lng;
          let dest = this.$data.deliveryJob.destAddress;
          let self = this;
          getDistance(orig, dest)
          .then(function(data) {
            if(data.success == true) {
              // console.log(data.message);
              self.drawRoutes(data.message);
            }
          })
          .catch(function(err) {
            // console.log(err);
          })
        },
        drawRoutes:function(data) {
          data = JSON.parse(data);
          let routes = data.routes;
          let legs = routes[0].legs;
          let leg = legs[0];
          // console.log("leg");
          // console.log(legs);
          let steps = leg.steps;

          this.$data.destination = leg.end_location;
          let routePoints = [];
          const bounds = new google.maps.LatLngBounds();
          for(let i = 0 ; i < steps.length ; i++) {
            let points = this.decode(steps[i].polyline.points);
            // console.log("points");
            // console.log(points);
            routePoints.push.apply(routePoints, points);
          }
          for(let i = 0 ; i < routePoints.length ; i++) {
            bounds.extend({lat:routePoints[i].latitude, lng:routePoints[i].longitude});
            this.$data.lines.push({lat:routePoints[i].latitude, lng:routePoints[i].longitude});
          }
          // console.log(routePoints);
          this.$refs.gmap.$mapPromise.then((map) => {

            map.fitBounds(bounds);
          });
        },
        decode: function(encoded){

          // array that holds the points

          var points=[ ]
          var index = 0, len = encoded.length;
          var lat = 0, lng = 0;
          while (index < len) {
            var b, shift = 0, result = 0;
            do {

              b = encoded.charAt(index++).charCodeAt(0) - 63;//finds ascii                                                                                    //and substract it by 63
              result |= (b & 0x1f) << shift;
              shift += 5;
            } while (b >= 0x20);


            var dlat = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lat += dlat;
            shift = 0;
            result = 0;
            do {
              b = encoded.charAt(index++).charCodeAt(0) - 63;
              result |= (b & 0x1f) << shift;
              shift += 5;
            } while (b >= 0x20);
            var dlng = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
            lng += dlng;

            points.push({latitude:( lat / 1E5),longitude:( lng / 1E5)})

          }
          return points
        },
        sendReceipt: function(id) {
          let self = this;
          if(this.$data.receiptEmail === '' || this.$data.receiptEmail.includes("@") == false) {
            this.$modal.show('dialog',{
              title: "",
              text: "Please enter email to send receipt to",
              buttons:[
                {
                  title:'Close',
                  handler: () => {
                    self.$modal.hide('dialog');
                  }
                }
              ]
            })
          }

          sendReceipt(id, this.$data.receiptEmail)
          .then(function(data) {
            self.$modal.show('dialog',{
              title: "",
              text: data.message,
              buttons:[
                {
                  title:'Close',
                  handler: () => {
                    self.$modal.hide('dialog');
                  }
                }
              ]
            })
          })
          .catch(function(err) {
            self.$modal.show('dialog',{
              title: "ERROR",
              text: "Unexpected error happened",
              buttons:[
                {
                  title:'Close',
                  handler: () => {
                    self.$modal.hide('dialog');
                  }
                }
              ]
            })
          })
        }

      }
    }
</script>

<style scoped>
.status-icon-box {
  width: 50px;
  height: 50px;
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

}
.status-icon-0 {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_acceptance-gray_ic.png');
}
.status-icon-0.enabled {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_acceptance-orange_ic.png');
}
.status-icon-4 {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_kitchen-gray_ic.png');
}
.status-icon-4.enabled {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_kitchen-orange_ic.png');
}
.status-icon-5 {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_collection-gray_ic.png');
}
.status-icon-5.enabled {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_collection-orange_ic.png');
}
.status-icon-6 {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_completed-gray_ic.png');
}
.status-icon-6.enabled {
  background-image: url('https://storage.googleapis.com/menus-275719.appspot.com/icons/order-status/kh_completed-orange_ic.png');
}

.dotted-line {
  position: absolute;
  width: 100%;
  height: 1px;
  top: 50%;
  border-bottom: 2px dotted #DADADA;
}
.dotted-line.enabled {
  border-bottom: 2px solid #E7344C;
}

</style>



// WEBPACK FOOTER //
// src/components/Order.vue